import { UnityBridge } from "@Context/common/general/context";
import { eventRegistry } from "@Context/common/general/event-context";
import * as t from "io-ts";
import { useEffect } from "react";

// Define the keyboard event type
const KeyboardEventCodec = t.type({
  type: t.literal("keyboard"),
  timestamp: t.number,
  action: t.union([t.literal("close"), t.literal("open")]),
});

type KeyboardEvent = t.TypeOf<typeof KeyboardEventCodec>;

// Create the keyboard event emitter
const keyboardEventEmitter = eventRegistry.registerEventType<typeof KeyboardEventCodec, KeyboardEvent>(
  "keyboard",
  KeyboardEventCodec
);

const KeyboardService = () => {
  useEffect(() => {
    // Subscribe to keyboard events
    const unsubscribe = keyboardEventEmitter.on((event) => {
      if (event.action === "close") {
        UnityBridge.dispatchWebEvent({
          type: UnityBridge.OutgoingWebEvents.TextFieldBlurred,
          payload: {},
        });
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return null;
};

export const closeKeyboard = () => {
  keyboardEventEmitter.emit({
    type: "keyboard",
    timestamp: Date.now(),
    action: "close",
  });
};

export default KeyboardService; 